module.exports = __webpack_public_path__ + "static/media/20.d6038d07.svg";